import React, { useState } from 'react'
import { Form, Row, Col, Modal, Select, Typography, Input, DatePicker, TimePicker } from 'antd';
import { platformApi } from '../../../../api'
import './style.less'
import moment from 'moment'
import { message } from 'antd';
import { withRouter } from 'react-router-dom'

import DiscardModal from '../../DiscardModal'

const { Item } = Form;
const { Text, Title } = Typography;
const { TextArea } = Input
const { Option } = Select
const AddActivityModal = (props) => {
  const { visibility, setVisibility, customerDetail, getActivityByCustomer, form, quotations } = props

  const defaultValue = {
    remarks: "",
    enquiryType: "",
    interactionType: "WALK IN",
    followUpDate: null,
    followUpTime: null,
  }
  const [discardModal, setDiscardModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    getFieldDecorator,
    resetFields,
    validateFields,
    getFieldValue,
    setFieldsValue,
  } = form;

  const createActivity = () => {
    // Prevent multiple submissions
    if (loading) return;

    // Validate form fields
    validateFields((err, values) => {
      if (err) {
        return;
      }

      setLoading(true);

      // Get values from form
      const formData = {
        remarks: values.remarks || "",
        enquiryType: values.enquiryType,
        interactionType: "WALK IN",
        followUpDate: values.followUpDate,
        followUpTime: values.followUpTime,
        customerId: customerDetail.id,
        quotation: values.quotationId
      };

      // Format dates for API
      const apiData = {
        ...formData,
        followUpDate: moment(formData.followUpDate).format('DD-MM-YYYY'),
        followUpTime: moment(formData.followUpTime).format('HH:mm')
      };

      platformApi.post('/api/activity/create', apiData)
        .then(res => {
          message.success("Activity Added Successfully");
          getActivityByCustomer();
          close();
        })
        .catch(err => {
          message.error("Activity Creation Failed");
          setLoading(false);
        });
    });
  }

  const close = () => {
    // Reset form and state before closing
    resetFields();
    setLoading(false);
    setDiscardModal(false);
    setVisibility(false);
  }

  const disabledDate = (current) => {
    // Can not select days before today
    return current && current < moment().startOf('day');
  }

  const getDisabledHours = () => {
    // Always disable these hours regardless of date
    const disabledHours = [0, 1, 2, 3, 4, 5, 6, 7, 20, 21, 22, 23];

    const followUpDate = getFieldValue('followUpDate');
    const today = moment().startOf('day');

    // If date is selected and it's today
    if (followUpDate && moment(followUpDate).isSame(today, 'day')) {
      const currentHour = moment().hour();
      // Disable all hours that have already passed today
      for (let i = 0; i < currentHour; i++) {
        if (!disabledHours.includes(i)) {
          disabledHours.push(i);
        }
      }
    }

    // Return unique sorted hours
    return [...new Set(disabledHours)].sort((a, b) => a - b);
  };

  const getDisabledMinutes = (selectedHour) => {
    const followUpDate = getFieldValue('followUpDate');
    const today = moment().startOf('day');

    // Only disable minutes if selected date is today AND selected hour is current hour
    if (followUpDate && moment(followUpDate).isSame(today, 'day') && selectedHour === moment().hour()) {
      const currentMinute = moment().minute();
      const disabledMinutes = [];
      for (let i = 0; i < currentMinute; i++) {
        disabledMinutes.push(i);
      }
      return disabledMinutes;
    }

    // For future dates or different hours, return empty array (no minutes disabled)
    return [];
  };

  const leadSources = [
    { key: "WALK IN", title: "Walk In" },
  ];

  const enquiryTypes = ["Hot", "Warm", "Cold"];

  return (
    <Modal
      title={<Title level={4}>Add Walk-In Activity</Title>}
      visible={visibility}
      onOk={createActivity}
      cancelText={"Cancel"}
      onCancel={close}
      okText="Create"
      confirmLoading={loading}
      wrapClassName="add-activity-modal"
      destroyOnClose={true}
    >
      <Form layout="vertical">
        <Row type="flex" justify="space-between" gutter={[16, 16]}>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <strong>Customer Name: </strong>
                {customerDetail.name}
              </Col>
              <Col span={6}>
                <strong>Followup Date & Time : </strong>
              </Col>
              <Col span={4}>
                <Form.Item required>
                  {getFieldDecorator('followUpDate', {
                    rules: [{ required: true, message: 'Please select follow-up date' }]
                  })(
                    <DatePicker
                      format="DD-MM-YYYY"
                      disabledDate={disabledDate}
                      placeholder="Select Date"
                      inputReadOnly={true}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item required>
                  {getFieldDecorator('followUpTime', {
                    rules: [
                      { required: true, message: 'Please select follow-up time' },
                      {
                        validator: (rule, value, callback) => {
                          const followUpDate = getFieldValue('followUpDate');
                          if (followUpDate && value) {
                            const selectedDateTime = moment(followUpDate)
                              .hour(value.hour())
                              .minute(value.minute())
                              .second(0)
                              .millisecond(0);
                            
                            if (selectedDateTime.isBefore(moment().subtract(1, 'minute'))) {
                              callback('Follow-up time cannot be in the past');
                              return;
                            }
                          }
                          callback();
                        }
                      }
                    ]
                  })(
                    <TimePicker
                      format="HH:mm"
                      disabled={!getFieldValue('followUpDate')}  // Disable time picker if no date selected
                      disabledHours={getDisabledHours}
                      disabledMinutes={getDisabledMinutes}
                      placeholder="Select Time"
                      hideDisabledOptions={true}
                      inputReadOnly={true}
                    />
                  )}
                </Form.Item>
              </Col>

            </Row>
          </Col>

          <Col span={24} style={{ marginTop: '20px' }}>
            <Row gutter={[16, 16]}>
              <Col span={6}>
                <strong>Interaction Type</strong>
              </Col>
              <Col span={8}>
                {getFieldDecorator('interactionType', {
                  initialValue: "WALK IN"
                })(
                  <Select disabled={true}>
                    {leadSources.map(source =>
                      <Select.Option key={source.key}>{source.title}</Select.Option>
                    )}
                  </Select>
                )}
              </Col>
              <Col span={10} style={{ marginTop: '-42px' }}>
                <Form.Item label={<Text>Enquiry Type</Text>} required>
                  {getFieldDecorator("enquiryType", {
                    rules: [{ required: true, message: "Please select Enquiry Type" }],
                  })(
                    <Select
                      placeholder="Enquiry Type"
                      showAction={["click", "focus"]}
                    >
                      {enquiryTypes.map((type) => (
                        <Select.Option value={type} key={type}>
                          {type}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col span={24}>
            <Form.Item label={<Text strong>Select Quotation</Text>}>
              {getFieldDecorator('quotationId', {
                initialValue: quotations && quotations.length === 1 ? quotations[0].id : undefined,
                rules: [{ required: false, message: 'Please select quotation' }]
              })(
                <Select placeholder="Select Quotation" allowClear>
                  {quotations?.map(q => (
                    <Select.Option key={q.id} value={q.id}>
                      {q.quotationId}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <strong>Remarks:</strong>
            <Form.Item>
              {getFieldDecorator('remarks', {
                initialValue: "",
                rules: [
                  {
                    pattern: /^[a-zA-Z0-9\s.,!?'"()-]*$/,
                    message: 'Only letters, numbers, spaces and basic punctuation (. , ! ? \' " ( ) -) are allowed'
                  },
                  {
                    max: 500,
                    message: 'Remarks cannot exceed 500 characters'
                  }
                ]
              })(
                <TextArea
                  rows={4}
                  placeholder="Enter remarks"
                  maxLength={500}
                  onKeyUp={(e) => {
                    // Allow only alphanumeric, spaces, and basic punctuation
                    let value = e.target.value;
                    value = value.replace(/[^a-zA-Z0-9\s.,!?'"()-]/g, '');
                    if (value !== e.target.value) {
                      form.setFieldsValue({
                        remarks: value
                      });
                    }
                  }}
                  onInput={(event) => {
                    // Real-time filtering of special characters
                    const rawValue = event.target.value;
                    const filteredValue = rawValue.replace(/[^a-zA-Z0-9\s.,!?'"()-]/g, '');
                    if (filteredValue !== rawValue) {
                      event.target.value = filteredValue;
                      form.setFieldsValue({
                        remarks: filteredValue
                      });
                    }
                  }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={24}>
            <span className="linkylink" onClick={() => setDiscardModal(true)}>Discard Followup</span>
          </Col>
        </Row>
      </Form>

      <DiscardModal
        visibility={discardModal}
        setVisibility={setDiscardModal}
        customerDetail={customerDetail}
      />
    </Modal>
  )
}

const WrappedAddActivityModal = Form.create({
  name: "walkin_interface"
})(AddActivityModal);

export default withRouter(WrappedAddActivityModal);